import { render, staticRenderFns } from "./StatsKyc.vue?vue&type=template&id=1577d069&"
import script from "./StatsKyc.vue?vue&type=script&lang=js&"
export * from "./StatsKyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports